export default __webpack_public_path__ + "static/media/books.3349bb79.jpeg";